import Vue from "vue"
import VueTimers from "vue-timers"
import App from "@/App"
import router from "@/router"
import User from "@/lib/user"
import axios from "axios"
import vuetify from "./plugins/vuetify"
import Toasted from "vue-toasted"
import EventBus from "@/lib/eventBus"
import store from "@/store"
import { apiConfig } from "@/lib/config"
import ActionCableVue from "actioncable-vue"
import * as Sentry from "@sentry/browser"
import * as Integrations from "@sentry/integrations"

if (process.env.NODE_ENV == "production") {
  Sentry.init({
    dsn: apiConfig.sentryUrl,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: "error",
  connectionUrl: apiConfig.cableURL,
  connectImmediately: false
})

Vue.config.productionTip = false
Vue.use(Toasted)
Vue.use(VueTimers)

axios.interceptors.response.use(
  response => response,
  error => {
    if (
      error.message === "Network Error" &&
      router.currentRoute.name != "serverDown"
    ) {
      router.push({ name: "serverDown" })
    }
    if (error.response) {
      //TODO: We need to do something more useful than log http errors
      if (
        error.response.status == "401" &&
        error.response.statusText.includes("Your session expired")
      ) {
        User.removeToken("")
        if (router.currentRoute.path != "/login") {
          router.push({ name: "login" })
        }
        EventBus.$emit("flash", {
          text: `ERROR:  ${error.response.status} ${error.response.statusText}`,
          type: "error",
          visible: true
        })
      }
    }
    return Promise.reject(error)
  }
)

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app")

if (window.Cypress) {
  // only available during E2E tests
  window.app = app
}
